export default __webpack_public_path__ + "static/media/wanna2.88e118fc.png";